import { IdentityParameter } from "@/features/types";
import { pluralizeCompanyType } from "@/features/ui/helpers/identity-helpers";

export function getUrlPrefixByIdentityParameter(paramter: IdentityParameter) {
  return `${pluralizeCompanyType(paramter.by).toLowerCase()}/${
    paramter.companyId
  }`;
}
